<template>
  <div class="bg-white p-4 rounded-xl fixed right-0 w-full sm:right-4 sm:w-auto bottom-0 sm:top-[50%] sm:bottom-auto z-[999] shadow-md" v-if="enabled" @mouseover="stopTimer" @mouseleave="startTimer">
    <div class="flex items-center gap-2 font-bold">
      <img
        src="~/assets/check-mark.png"
        class="h-4 w-auto"
      />
        Повтор заказа
    </div>
    <div class="flex flex-col">
        <div class="m-4">Вы можете повторить ваш последний заказ</div>
        <SimpleButton
            class="p-4 rounded-xl text-[0.7rem] font-medium uppercase text-white lg:text-sm"
            type="button"
            @click="repeatOrder()"
        >
            <slot> Добавить блюда в корзину </slot>
        </SimpleButton>
    </div>
  </div>
</template>

<script setup lang="ts">

import { ref } from 'vue'
import { useToast } from 'vue-toastification'
import MyToast from '~/components/MyToast.vue'

const props = defineProps<{
    orderId: number
}>()


const showPopupCookie = useCookie('show_repeat_order', {
    watch: 'shallow',
    expires: new Date(new Date().getTime() + 60 * 60 * 24 * 1000),
})

let enabled = ref(showPopupCookie.value != "1")

if(showPopupCookie.value != "1") {
    showPopupCookie.value = "1"
}

let timerId: any
const startTimer = () => {
    timerId = setTimeout(() => {
        enabled.value = false
    }, 5000)
}
startTimer()
const stopTimer = () => {
    clearTimeout(timerId)
}

const { mutate } = useFillFromOrder()

const toast = useToast()
const repeatOrder = () => {
    mutate(props.orderId, {
        onSuccess: () => {
            enabled.value = false

            toast({
                component: MyToast,
                props: {
                    title: 'Повтор заказа',
                    detail: 'Добавили в корзину блюда из последнего заказа',
                },
            })
        }
    })
}
</script>
